import { useHistory } from 'react-router-dom';

import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';

import CookingHistoryList from '../../components/cookingHistory/CookingHistoryList';
import { GoBackIcon } from '../../utils/iconRefs/recipeRatingIcons';
import styles from "./CookingHistory.module.css"

const CookingHistory = () => {
    const history = useHistory();

    const onBack = () => {
        if (history.length > 1) {
            history.push('/account');
        } else {
            history.push('/cooking-history')
        }
        sessionStorage.setItem('scrollheightCookingHistory', '0');
    }

    return (
        <>
            <Grid className={styles.container} container spacing={2}>
                <Grid className={styles.title_container}>
                    <GoBackIcon onClick={onBack} />
                    <Typography className={styles.title} color="#fff" variant="h6">
                        Cooking History
                    </Typography>
                </Grid>
                <Grid className={styles.filterIcon} id="filter-icon" />
            </Grid>
            <CookingHistoryList />
        </>
    )
}

export default CookingHistory